import React, { createContext, ReactElement, useState } from 'react'
import styled from 'styled-components'

interface IProps {
    children: ReactElement[],
    tabHeaders: ReactElement[]
}

export interface ITabsContext {
    step: number,
    totalNumberOfSteps: number,
    activateStep: (step: number) => void
}

const TabHeadersContainer = styled.div`
    font-size: x-large;
`;

const TabContentsContainer = styled.div`
    width: 100%;
    padding-left: 1.5em;
    border-top: solid 2px green;
    padding-top: 1em;
`;

const TabsContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const TabsContext = createContext({} as ITabsContext);

export default function Tabs(props: IProps) {
    const [step, setStep] = useState<number>(0);

    const activateStep = (step: number) => {
        setStep(step);
    }

    return <TabsContext.Provider value={{ step, activateStep, totalNumberOfSteps: props.tabHeaders.length }}>
        <TabsContainer>
            <TabHeadersContainer>
                {props.tabHeaders}
            </TabHeadersContainer>
            <TabContentsContainer>
                {props.children}
            </TabContentsContainer>
        </TabsContainer>
    </ TabsContext.Provider>;
}